import React,{ useState } from 'react'
import { resetPassword } from '../../../firebase';
import { Link } from 'react-router-dom';

export default function ForgetPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSignInSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    resetPassword(email).then(()=>{
      setError("");
      setLoading(false);
    }).then(()=>{
      setMsg('Password reset link set to your registered email Id');
    }).catch((error) => {
      setMsg("");
      setError("Something went wrong");
      setLoading(false);
    });
  }

  return (
    <section id="contact" className="contact">
      <div className="container " data-aos="fade-down">
        <div className="login-title mt-3">
          <h2>Reset Your Password</h2>
        </div>
      </div>

      <div className="row " style={{ justifyContent: "center" }}>
        <div className="col-lg-4 mt-5 mt-lg-0 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={200}>
          <div className="php-email-form" >
            <form onSubmit={onSignInSubmit}>
              <div className="row text-align-center">
                <div className="form-group col-md-12">
                  <input type="email" name="email" className="form-control mb-2" readOnly={loading} value={email}
                    onChange={(e) => setEmail(e.target.value)} id="email" placeholder="Email Id" required />
                </div>
                <div className="form-group col-md-12">
                  <button type="submit" disabled={!email || loading}>Reset</button>
                </div>
              </div>
            </form>
            {msg && <div className="alert alert-success" role="alert">{msg}</div>}
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <div className='mt-2'>
              <Link to="/login">Go to SignIn</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
